import { request } from '@/utils/request';

export function getInvoiceList (params) {
  return request('/zlb/api/invoice/operation/query', {
    params,
    method: 'get',
  });
}

// 发票详情
// export function getInvoiceInfo (params) {
//   return request('/zlb/api/invoice/detailNew', {
//     params,
//   });
// }

// 发票详情
export function getInvoiceInfo (params) {
  return request('/zlb/api/invoice/operation/detail', {
    params,
  });
}
// ocr识别
export function OCRDistinguish (data) {
  return request('/zlb/api/invoice/operation/ocr', {
    method: 'POST',
    data,
  });
}

// ocr详情
export function getOcrDetail (params) {
  return request('/zlb/api/invoice/operation/invoice-ocr-detail', {
    method: 'get',
    params,
  });
}


